module.exports = __webpack_public_path__ + "img/Psych_text04b_goalpred.a293fd2d.png";